import { toRpcSpec } from '@/dashboard/lib/to-rpc-spec';
import type { DashboardSpec } from '@/dashboard/types';

/** The dashboard snapshot shape sent to the agent preamble (`<current_dashboard_draft>`). */
export interface AgentDashboardSnapshot {
  title: string;
  slug: string;
  warehouseId: string;
  description?: string | null;
  spec: { parameters: Record<string, unknown>[]; panels: Record<string, unknown>[] };
}

/** Project a dashboard/artifact into the agent-preamble wire shape (RPC spec + null-defaulted description). */
export function toAgentDashboardSnapshot(input: {
  title: string;
  slug: string;
  warehouseId: string;
  description?: string | null;
  spec: DashboardSpec;
}): AgentDashboardSnapshot {
  const rpcSpec = toRpcSpec(input.spec);
  return {
    title: input.title,
    slug: input.slug,
    warehouseId: input.warehouseId,
    description: input.description ?? null,
    spec: {
      parameters: rpcSpec.parameters as unknown as Record<string, unknown>[],
      panels: rpcSpec.panels,
    },
  };
}
